import { useAssistantStorage } from "@/composables/useAssistantStorage";

import { Keys } from "@/composables/usePreferences";

const bus = useEventBus<string>("main");

export const useChatStore = defineStore("chat", () => {
  const { assistantStorage } = useAssistantStorage();

  const id = useStorageAsync(Keys.chatId, undefined, assistantStorage);

  const messages = useStorageAsync(
    Keys.chatHistory,
    <Message[]>[],
    assistantStorage,
    {
      serializer: {
        read: (value: string) => {
          return value ? JSON.parse(value) : null;
        },
        write: (value: Message[]) => {
          return JSON.stringify(value);
        },
      },
    },
  );

  const awaitingReply = ref(false);

  const messagesCount = computed(() => messages.value.length);

  const addMessage = (
    content: string = "",
    role: Role = "assistant",
    id: string = "",
    richData: IRichData[] = [],
  ): string => {
    // const id = uuidv4();
    const time = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    messages.value.push({
      id,
      role,
      content,
      time,
      rich_data: richData,
    });

    // Fire updated event
    bus.emit("chat:updated");
    // Return id
    return id;
  };

  const removeLastMessage = () => {
    messages.value.pop();
  };

  const removeLastMessages = (amount = 1) => {
    messages.value = messages.value.slice(0, -amount);
  };

  const clearMessages = () => {
    id.value = undefined;
    messages.value = [];
  };

  const reset = () => {
    id.value = undefined;
    awaitingReply.value = false;
    clearMessages();
  };

  return {
    id,
    messages,
    messagesCount,
    awaitingReply,
    addMessage,
    removeLastMessage,
    removeLastMessages,
    clearMessages,
    reset,
  };
});
